import { render } from "./FormSignUp.vue?vue&type=template&id=003c5d4e&scoped=true"
import script from "./FormSignUp.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSignUp.vue?vue&type=script&setup=true&lang=js"

import "./FormSignUp.vue?vue&type=style&index=0&id=003c5d4e&lang=scss&scoped=true"
import "./FormSignUp.vue?vue&type=style&index=1&id=003c5d4e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-003c5d4e"],['__file',"src/views/auth/FormSignUp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "003c5d4e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('003c5d4e', __exports__)) {
    api.reload('003c5d4e', __exports__)
  }
  
  module.hot.accept("./FormSignUp.vue?vue&type=template&id=003c5d4e&scoped=true", () => {
    api.rerender('003c5d4e', render)
  })

}


export default __exports__